import React from 'react';
import { Check } from 'jbc-front/components/icons';

const Checked = ({ checked, defaultValue = '—' }) => <span>{checked ? <Check size={16} /> : defaultValue}</span>;

export default Checked;
